import React from "react";

function EyesIcon() {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.8">
        <path
          d="M15.1193 12.0079C15.8385 11.294 16.3937 10.5846 16.7566 10.0759C16.993 9.74433 17.1112 9.57851 17.1112 9.33312C17.1112 9.08773 16.993 8.92191 16.7566 8.59034C15.694 7.10046 12.9806 3.88867 9.33344 3.88867C8.62738 3.88867 7.95631 4.00904 7.32543 4.21399M5.2481 5.24778C3.67992 6.30538 2.52178 7.73296 1.91036 8.59034C1.67389 8.92191 1.55566 9.08773 1.55566 9.33312C1.55566 9.57851 1.67389 9.74433 1.91036 10.0759C2.97285 11.5658 5.68627 14.7776 9.33344 14.7776C10.8818 14.7776 12.2619 14.1987 13.4188 13.4185"
          stroke="#9E9E9E"
          strokeWidth="1.16667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.66722 7.77734C7.25498 8.18957 7 8.75913 7 9.3882C7 10.6463 8.0199 11.6662 9.27803 11.6662C9.9071 11.6662 10.4767 11.4113 10.8889 10.999"
          stroke="#9E9E9E"
          strokeWidth="1.16667"
          strokeLinecap="round"
        />
        <path
          d="M2.33301 2.33301L16.333 16.333"
          stroke="#9E9E9E"
          strokeWidth="1.16667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

export default EyesIcon;
